'use client'

// lib files
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:dotorg-next":true});}catch(e){}}();import { useState } from 'react';

// svgs
import AddIcon from '@/public/svg/add.svg';
import MinusIcon from '@/public/svg/minus.svg';

// types
import { PassportTransferFAQItem } from './PassportTransferFAQContent';

// styles
import styles from './PassportTransferFAQ.module.scss';

interface PassportTransferFAQProps {
  faqBank: PassportTransferFAQItem[];
}

export default function PassportTransferFAQ(props: PassportTransferFAQProps) {
  const { faqBank } = props;
  const [isOpen, setisOpen] = useState(false);
  const content = faqBank.map((item, i) => {
    const { question, answer } = item;
    return (
      <li key={i} className={styles.passport_transfer_faq__item}>
        <div className={styles.passport_transfer_faq__question}>
          <h3>{question}</h3>
        </div>
        <div className={styles.passport_transfer_faq__answer}>
          <p>{answer}</p>
        </div>
      </li>
    )
  })

  const handleToggleFAQ = () => {
    setisOpen(previsOpen => {
      return !previsOpen
    })
  }

  return (
    <div className={styles.passport_transfer_faq} data-sentry-component="PassportTransferFAQ" data-sentry-source-file="PassportTransferFAQ.tsx">
      <div className={styles.passport_transfer_faq__header} onClick={() => handleToggleFAQ()}>
        <h2>Frequently Asked Questions</h2>
        <button aria-label={isOpen ? 'Close FAQ' : 'Open FAQ'} className={styles.passport_faq_toggle_icon}>
          {!isOpen && <AddIcon />}
          {isOpen && <MinusIcon />}
        </button>
      </div>
      { isOpen &&
        <ul className={styles.passport_faq_answer}>
          {content}
        </ul>
      }
    </div>
  )
}
